import React from "react";

import Tips from "../../../components/tips/tips";
import {useSelector} from "react-redux";
import {subMerchantMaterialInfoSelector} from "../../../store/merchant";

const Audit = (props) => {
    let subMerchantMaterialInfo = useSelector(subMerchantMaterialInfoSelector);
    let {field} = props;
    let message = subMerchantMaterialInfo.rejections[field];
    let ctx = {
        type: 'error',
        ctx: message,
    };
    return message !== undefined && message ? (
        <div className='audit'>
            <Tips ctx={ctx}/>
        </div>
    ) : null;
}

export default Audit;